<template>
    <div class="alerts-container">
        <b-alert variant="success" :show="hasSuccessMessage" dismissible @dismissed="dismissMessage('success')">
            {{ messages.success }}
        </b-alert>
        <b-alert variant="warning" :show="hasWarningMessage" dismissible @dismissed="dismissMessage('warning')">
            {{ messages.warning }}
        </b-alert>
        <b-alert variant="danger" :show="hasErrorMessages" dismissible @dismissed="dismissMessage('error')">
            <span v-html="formattedErrorMessage"></span>
        </b-alert>
    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex';

    export default {

        computed: {

            ...mapState(['messages']),

            hasSuccessMessage() {
                return this.messages.success !== '';
            },
            hasWarningMessage() {
                return this.messages.warning !== '';
            },
            hasErrorMessages() {
                return this.messages.error.length > 0;
            },
            formattedErrorMessage() {
                return `<div>${this.messages.error.join('</div><div>')}</div>`;
            }

        },

        methods: {

            ...mapActions(['dismissMessage'])

        }

    };

</script>



// WEBPACK FOOTER //
// src/components/Alerts/Alerts.vue